import React from "react";
import { MicroCourse } from "../../../modules/academy/models";
import { MicroCourseCard } from "./MicroCourseCard";

export interface MicroCourseListProps {
  microCourses?: MicroCourse[];
  completedMicroCourses?: string[];
  inProgressMicroCourseId?: string | null;
  isGuest: boolean;
  isKid?: boolean;
  onMarkCompleted?: (microCourseId: string) => void;
  onStartMicroCourse?: (microCourseId: string) => void;
}

export function MicroCourseList({
  microCourses,
  completedMicroCourses,
  inProgressMicroCourseId,
  isGuest,
  isKid,
  onMarkCompleted,
  onStartMicroCourse,
}: MicroCourseListProps) {
  if (!microCourses || microCourses.length === 0) {
    return (
      <section className="rounded-2xl border shadow-sm p-5 bg-white dark:bg-slate-900 dark:border-slate-700">
        <h2 className="text-lg font-semibold mb-2">Micro-cours</h2>
        <p className="text-sm text-slate-600 dark:text-slate-300">
          Aucun micro-cours defini pour ce theme pour l'instant.
        </p>
      </section>
    );
  }

  return (
    <section className="space-y-3">
      <h2 className="text-lg font-semibold">Micro-cours</h2>
      <div className="grid gap-4 md:grid-cols-2">
        {microCourses.map((mc) => {
          const isCompleted = completedMicroCourses?.includes(mc.id) ?? false;
          const isInProgress = inProgressMicroCourseId === mc.id;
          return (
            <MicroCourseCard
              key={mc.id}
              microCourse={mc}
              isCompleted={isCompleted}
              isInProgress={isInProgress}
              isGuest={isGuest}
              isKid={isKid}
              onStart={() => onStartMicroCourse?.(mc.id)}
              onMarkCompleted={() => onMarkCompleted?.(mc.id)}
            />
          );
        })}
      </div>
    </section>
  );
}
